import { useEffect, useState } from "react";
import config from "../../config";
import app from "../../components/app";

const fetchPost = async function(data, mode) { 
    if(!mode) {
      app.preloader(true);
    }
    data["project"] = "templates";
    let response = await fetch(app.config().postURL, {
      // body:JSON.stringify({
      //     payload:cryptography.encrypt2(JSON.stringify(data))
      // }),
      body:JSON.stringify(data),
      method: "POST",
      // headers:{
      //   'Content-Type': 'application/json'
      // }
    });
    response = await response.json();
    //response = JSON.parse(cryptography.decrypt2(response.data));
    
    console.log(data, response);

    if(!mode) {
      app.preloader(false);
    }
    return response;
}




const Form = function({data, id, index, callback}){
    const [item, setItem] = useState(data?data:app.defaultData("templateKeys"));
    console.log(item);
    const saveBlock = function(){
        if(item["name"] === "") {
            alert("Enter valid page name!");
            return false;
        }
        if(item["key"] === "") {
            alert("Enter valid page KEY!");
            return false;
        }
        if(!item.data) {
            item.data = JSON.stringify({
              webJson:{
  "card": {
    "log_id": "divkit_web_card",
    "states": [
      {
        "state_id": 0,
        "div": {
          "type": "container",
          "items": [],
          "width": {
            "type": "match_parent"
          },
          "height": {
            "type": "wrap_content"
          },
          "paddings": {
            "left": 0,
            "right": 0,
            "top": 0,
            "bottom": 0
          },
          "background": [
            {
              "type": "solid",
              "color": "#FFFFFF"
            }
          ]
        }
      }
    ]
  },
  "templates": {}
},
"mobileJson":{
  "card": {
    "log_id": "divkit_mobile_card",
    "states": [
      {
        "state_id": 0,
        "div": {
          "type": "container",
          "width": {
            "type": "match_parent"
          },
          "items": [],
          "height": {
            "type": "wrap_content"
          },
          "paddings": {
            "left": 0,
            "right": 0,
            "top": 0,
            "bottom":0
          },
          "background": [
            {
              "type": "solid",
              "color": "#FFFFFF"
            }
          ]
        }
      }
    ]
  },
  "templates": {}
}
        }

            )
        }
        console.log(item);
        fetchPost({
            ...item,
            "method":item.id?"update":"insert"
        }).then(function(response){
            console.log(response);
            if(response.success) {
                alert("Page information successfully saved and updated!");
                if(callback) {
                    callback(response.data, index);
                    document.querySelector("#" + id).remove();
                }
            }
            else {
                alert(response.error);
                document.querySelector("#" + id).remove();
            }
        })
   }
    const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    if(id === "status") {
      setItem({
        ...item,
        status: e.target.getAttribute("data-value") === "1"?1:0,
      });
    }
    else {
      setItem({
        ...item,
        [id]: type === 'checkbox' ? checked : value,
      });
    }
  };

  
    
    return <div className={`w-100`}>
      {
                    config.templateKeys.map(function(v){
                      let input = <input type="text" id={v.key} className="form-control" value={item[v.key]} onChange={handleChange} placeholder={v.placeholder} />
                      if(v.type === "textarea") {
                        input = <textarea className="form-control" id={v.key} placeholder={v.placeholder.toString()} value={item[v.key]} onChange={handleChange} />
                      }
                      if(v.type === "select") {
                        input = <select className="form-control" id={v.key} value={item[v.key]} onChange={handleChange}>
                          {
                            v.options.map(function(val){
                              return  <option key={val.value} value={val.value}>{val.text}</option>
                            })
                          }
                         
                        </select>
                      }
                      if(v.type === "tabs") {
                        input =  <div className="btn-group">
                          {
                            v.options.map(function(val){
                              let active = "";
                              if(val.value === item[v.key]) {
                                active = "active";
                              }
                              return <button key={`tab${val.value}`} type="button" id={v.key} onClick={handleChange} data-value={val.value} className={`btn btn-outline-primary ${active}`}>{val.text}</button>
                            })
                          }
                        </div>
                      }
                     
                      return  <div key={v.key}  className={`mb-3 ${v.type === "textarea"?"":"d-flex"} ${v.type === "hidden"?"d-none":""}`}>
                        <label className="form-label w-25">{v.text}</label>
                        <div className={`${v.type === "textarea"?"w-100":"w-75"}`}>{input}</div>
                      </div>
                    })
                  }

                    <div className="modal-footer">
        <button type="button" className="btn btn-primary" onClick={saveBlock}>Save</button>
      </div>
    </div>
}


const Templates = function(){
     const [data, setData] = useState([]);
    useEffect(() => {
        fetchPost({
            "method":"getAll"
            //"method":"getActive"
        }).then(function(response){
            if(response.data) {
                setData(response.data.results);
            }
        })
    }, []);

    const updateData = function(item, index){
        if(index === undefined) {
            setData([item, ...data]);
        }
        else {
            setData(data.map(function(v, i){
                if(i === index) {
                    return item;
                }
                return v;
            }));
        }
    }

    const deleteItem = function(index) {
        if(window.confirm("do you really want to delete this Template")) {
            fetchPost({
                "method":"delete",
                "id":data[index].id
            }).then(function(){
                setData(data.filter(function(v, i){
                    if(i === index) {
                        return false;
                    }
                    return true;
                }))
            })
        }
    }

    const editItem = function(index) {
      const popupId = "block-popup";
      if(index === undefined) {
        app.createPopup(<Form callback={updateData} id={popupId} />, popupId);
      }
      else {
        fetchPost({
            "method":"get",
            "id":data[index].id
        }).then(function(response){
           app.createPopup(<Form index={index} data={response.data} callback={updateData} id={popupId} />, popupId);
        })
      }
      
        
    }
   
    return <div className="container-fluid p-0" style={{height:"100%", overflow:"scroll"}}>
    <div className="container p-0">
        <div className="w-100">
            <h2 className="p-0 mt-3">Templates <button className="btn btn-primary float-end" onClick={() => editItem()}>Add Template</button></h2>
            
        </div>
  <div className="row align-items-start">
    {
        data.map(function(v, i){
            return  <div key={`${v.id}`} className="col-3 pt-4">
                <div className="card" >
  <img src="/images/image-3x2.png" style={{backgroundImage:`url(${config.appkitCDN}/templates/en/desktop-${v.id}.png?version=${Date.now()})`, backgroundSize:"100%", backgroundRepeat:"no-repeat"}} className="card-img-top" alt="" />
  <div className="card-body">
  <h5 className="card-title">{v.title}</h5>
  <p className="card-text">
    <span className="badge bg-secondary me-2">{v.page}</span>
    <span className="badge bg-secondary">{v.category}</span>
  </p>
  
</div>
 <div className="card-footer">
  
  <button  className="btn btn-sm btn-danger me-2" onClick={() => deleteItem(i)}>delete</button>
   <a href={`/templates/${v.id}/preview`} className="btn btn-sm btn-primary me-2">preview</a>
   <button  className="btn btn-sm btn-primary me-2" onClick={function(){
   
    editItem(i);
   }}>edit Info</button>
   <a href={`/appkit-editor?templateId=${v.id}`} className="btn btn-sm btn-primary">edit</a>
  </div>

</div>
            </div>
        })
    }
  </div>
</div>

</div>

}

export default Templates;